import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calculator, FileText, ListChecks, QrCode, ArrowRight } from "lucide-react";
import QstLayout from "./QstLayout";
import QstAssistantWidget from "./QstAssistantWidget";

const TOOLS = [
  { icon: Calculator, title: "Rework Cost Calculator", desc: "Estimate the true cost of rework — labor, materials, schedule, penalties.", to: "/qst/tools/rework-cost", accent: "#F97316" },
  { icon: Calculator, title: "Injury Cost Calculator", desc: "Understand direct + indirect costs of a workplace injury.",                 to: "/qst/tools/injury-cost", accent: "#DC2626" },
  { icon: Calculator, title: "Training Savings Calculator", desc: "Compare training investment against potential cost avoidance.",         to: "/qst/tools/training-savings", accent: "#059669" },
  { icon: FileText,   title: "Toolbox Talk Builder", desc: "Draft a talk from an approved QST lesson (supervisor approval required).",     to: "/qst/tools/toolbox-builder", accent: "#0B2545" },
  { icon: ListChecks, title: "Material Verification Checklist", desc: "Pre-install checklist to prevent installation errors.",             to: "/qst/tools/checklist", accent: "#7C3AED" },
  { icon: QrCode,     title: "QR Code Lesson Generator", desc: "Turn any approved lesson into a scan-to-open QR for the jobsite.",         to: "/qst/tools/qr-generator", accent: "#0891B2" },
];

export default function QstToolsPage() {
  useEffect(() => { document.title = "Tools — Quality Safety Times"; }, []);
  return (
    <QstLayout>
      <QstAssistantWidget context={{ page: "tools" }} />
      <section className="bg-gradient-to-b from-[#0B2545] to-[#1D4ED8] text-white py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-xs uppercase tracking-widest text-[#F97316] font-bold">Tools</div>
          <h1 className="mt-2 text-4xl font-black tracking-tight">Practical tools that pay for themselves.</h1>
          <p className="mt-3 text-lg text-slate-200 max-w-2xl">
            Free, browser-based tools that turn a foreman's practical questions into numbers the office understands.
          </p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TOOLS.map((t) => (
            <Link key={t.title} to={t.to}
              className="group rounded-xl border border-slate-200 bg-white p-6 hover:shadow-md transition"
              data-testid={`qst-tool-tile-${t.title.split(' ')[0].toLowerCase()}`}>
              <div className="w-11 h-11 rounded-lg grid place-items-center" style={{ background: `${t.accent}18` }}>
                <t.icon className="w-5.5 h-5.5" style={{ color: t.accent }} />
              </div>
              <div className="mt-4 text-base font-bold text-[#0B2545]">{t.title}</div>
              <div className="mt-1.5 text-sm text-slate-600 leading-relaxed">{t.desc}</div>
              <div className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-[#F97316] group-hover:translate-x-0.5 transition">
                Open <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </QstLayout>
  );
}
